<basic-info-form *ngIf="owner.opsubType === 'OFO' || owner.opsubType === 'OPO'" [basicInfo]="basicInfo"></basic-info-form>

<address-form
  [collapsed]="owner.subjectDetail && owner.subjectDetail.customAddressUse"
  [address]="address"
  toggleText="Jiná adresa než v datech KN"
  (toggle)="onToggleAddress($event)"
></address-form>

<address-form
  [collapsed]="owner.subjectDetail && owner.subjectDetail.dorucovaciUse"
  [address]="mailingAddress"
  heading="Doručovací adresa"
  toggleText="Jiná doručovací adresa"
  (toggle)="onToggleMailingAddress($event)"
></address-form>

<contact-form [contactInfo]="owner.subjectDetail"></contact-form>

<representative-form [representative]="contactPerson" [allowRoleAssignment]="false" heading="Kontaktní osoba"></representative-form>

<fieldset *ngIf="owner.opsubType === 'BSM'">
  <legend>Platební údaje</legend>
  <div class="column-100">
    <label (click)="toggleSinglePayment()">Jedna platba za podíl SJM</label>
    <div class="info">
      <gmt-checkbox [gmtChecked]="owner.subjectDetail.singlePayment" (click)="toggleSinglePayment()"></gmt-checkbox>
    </div>
  </div>

  <div *ngIf="owner.subjectDetail.singlePayment">
    <div class="column-100">
      <label>Manželé</label>
      <div class="info">
        <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: owner.partner1.id, tab: 'about' }">{{ owner.partner1 | subjectName }}</a>
        a
        <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: owner.partner2.id, tab: 'about' }">{{ owner.partner2 | subjectName }}</a>
      </div>
    </div>
    <payment-form [paymentOptions]="owner.subjectDetail" [nestedForm]="true" [withPaymentDetails]="false"></payment-form>
  </div>

  <ng-container *ngIf="!owner.subjectDetail.singlePayment">
    <div>
      <div class="column-100 bordered-top mt-10 pt-10">
        <label>Jméno</label>
        <div class="info">
          <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: owner.partner1.id, tab: 'about' }">{{ owner.partner1 | subjectName }}</a>
        </div>
      </div>
      <payment-form  [paymentOptions]="owner.partner1.subjectDetail" [nestedForm]="true" [withPaymentDetails]="false"></payment-form>
    </div>
  </ng-container>

  <ng-container *ngIf="!owner.subjectDetail.singlePayment">
    <div>
      <div class="column-100 bordered-top mt-10 pt-10">
        <label>Jméno</label>
        <div class="info">
          <a uiSref="symap.project.owners.detail" [uiParams]="{ ownerId: owner.partner2.id, tab: 'about' }">{{ owner.partner2 | subjectName }}</a>
        </div>
      </div>
      <payment-form  [paymentOptions]="owner.partner2.subjectDetail" [nestedForm]="true" [withPaymentDetails]="false"></payment-form>
    </div>
  </ng-container>
</fieldset>

<payment-form *ngIf="owner.opsubType !== 'BSM'" [paymentOptions]="owner.subjectDetail" [withPaymentDetails]="false"></payment-form>

<div class="centered-text">
  <div class="mb-5 text-center" [gmtAuth]="'admin,update_case_data'">
    <gmt-checkbox [gmtChecked]="actualizeAll" (click)="actualizeAll = !actualizeAll"></gmt-checkbox> Aktualizovat změny i u všech existujících případů (příp. odlišné údaje budou přepsané).<br>
  </div>
  <gmt-button [clickAction]="onSubmit">Uložit údaje</gmt-button>
</div>
